/* eslint-disable import/prefer-default-export */
export const autoHideDuration = 6000;
